import type { AppData } from '../../shared/types/index.js';

/** Index of app key → display name, built from the `apps` list the server sends next to a payload. */
export function buildAppNameIndex(apps: ReadonlyArray<AppData> = []): Map<string, string | undefined> {
  return new Map(apps.map(({ bundle, name }) => [bundle, name]));
}

/** Turns bare app keys into `{ bundle, name }` pairs using the index (unknown keys keep an undefined name). */
export function attachAppNames(bundles: ReadonlyArray<string>, names: Map<string, string | undefined>): Array<AppData> {
  return bundles.map(bundle => ({ name: names.get(bundle), bundle }));
}
